import { ISelectItem } from "@/types";
import {
  IStaff,
  IStaffCreateRequest,
  IStaffRequest,
  IStaffUpdateRequest,
} from "@/types/staff";

export class Staff implements IStaff {
  public id = 0;
  public name = "";
  public email = "";
  public tel = "";
  public partner_id = 0;
  public company_id = 0;
  public created_at = "";
  public updated_at = "";

  public constructor(props?: IStaff) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(staff: IStaff): ISelectItem {
    return {
      text: staff.name,
      value: staff.id,
    };
  }
}

export class StaffRequest implements IStaffRequest {
  name = "";
  email = "";
  tel = "";
  [key: string]: unknown;

  public constructor(props?: IStaff) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

export class StaffCreateRequest
  extends StaffRequest
  implements IStaffCreateRequest {}

export class StaffUpdateRequest
  extends StaffRequest
  implements IStaffUpdateRequest {}
